/* INTEGY V690 — mobile drawer visual-viewport + scroll guard. */
(function () {
  'use strict';
  var root = document.documentElement;
  var lastOpen = false;
  var lastHeight = 0;
  var frameQueued = false;
  /* V765.10: Empire can signal an open drawer via panel animation state
     before data-open is updated. Recognize both without treating closed
     panels as open and without observing unrelated page elements. */
  function activeDrawer() {
    var direct = document.querySelector('.site-mobile-nav[data-open="true"], [data-mobile-nav][data-open="true"]');
    if (direct) return direct;
    var nav = document.querySelector('.site-mobile-nav, [data-mobile-nav]');
    if (!nav) return null;
    var panel = nav.querySelector('.mobile-nav-panel, [data-mobile-nav-panel]');
    if (!panel) return null;
    var state = panel.getAttribute('data-animation-state') || '';
    var animation = panel.getAttribute('data-animation') || '';
    if (state === 'open' || animation === 'open' || animation === 'closed=>open' ||
        nav.classList.contains('is-open') || nav.classList.contains('open')) {
      return nav;
    }
    return null;
  }

  function viewportHeight() {
    var vv = window.visualViewport;
    return Math.max(240, Math.round(vv && vv.height ? vv.height : window.innerHeight || 0));
  }

  /* V765.7: avoid repainting the root during ordinary iPhone Safari scroll.
     Only a visible/open mobile drawer needs the visual-viewport-height token. */
  function syncViewport() {
    if (!activeDrawer()) return;
    var next = viewportHeight();
    if (Math.abs(next - lastHeight) < 2) return;
    lastHeight = next;
    root.style.setProperty('--integy-v690-mobile-vh', next + 'px');
  }

  function fixOpenDrawer() {
    var nav = activeDrawer();
    var open = !!nav;
    if (!open) { lastOpen = false; return; }
    syncViewport();
    var panel = nav.querySelector('.mobile-nav-panel, [data-mobile-nav-panel]');
    if (!panel) return;

    /* V765.9 mobile menu: avoid repeated style writes on submenu changes. */
    function once(k, v) {
      if (panel.style.getPropertyValue(k) !== v ||
          panel.style.getPropertyPriority(k) !== 'important')
        panel.style.setProperty(k, v, 'important');
    }
    once('overflow-x', 'hidden');
    once('overflow-y', 'auto');
    once('-webkit-overflow-scrolling', 'touch');
    once('touch-action', 'pan-y');
    once('height', 'var(--integy-v690-mobile-vh)');
    once('max-height', 'var(--integy-v690-mobile-vh)');
    if (panel.getAttribute('data-integy-v690-scroll-owner') !== 'true') panel.setAttribute('data-integy-v690-scroll-owner', 'true');

    /* Do not reset a user's scroll position when submenus open/close. */
    if (!lastOpen && panel.scrollTop < 0) panel.scrollTop = 0;
    lastOpen = true;
  }

  function scheduleFix() {
    if (!activeDrawer()) { lastOpen = false; return; }
    syncViewport();
    if (frameQueued) return;
    frameQueued = true;
    requestAnimationFrame(function () {
      frameQueued = false;
      var opening = !lastOpen;
      fixOpenDrawer();
      if (opening && lastOpen) {
        setTimeout(fixOpenDrawer, 80);
        setTimeout(fixOpenDrawer, 380);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleFix, { once: true });
  window.addEventListener('resize', scheduleFix, { passive: true });
  window.addEventListener('orientationchange', scheduleFix, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleFix, { passive: true });
    window.visualViewport.addEventListener('scroll', syncViewport, { passive: true });
  }

  /* The mobile drawer is present in the theme header. Watch it instead of
     all attributes on all page elements (reviews, product cards, filters, etc). */
  function bindDrawerObserver() {
    var nav = document.querySelector('.site-mobile-nav, [data-mobile-nav]');
    if (!nav || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' &&
            (m.attributeName === 'data-open' || m.attributeName === 'data-animation' ||
             m.attributeName === 'data-animation-state' || m.attributeName === 'open')) {
          scheduleFix();
          return;
        }
      }
    });
    observer.observe(nav, { subtree: true, attributes: true,
      attributeFilter: ['data-open','data-animation','data-animation-state','open'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDrawerObserver, { once: true });
  } else {
    bindDrawerObserver();
  }
})();
